import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/epoch-join-paypal.png")